import React from 'react';
import ExtendedModulePage from './ExtendedModulePage';
export default function SubjectGroupsPage(){ return <ExtendedModulePage moduleKey="subject-groups"/>; }
